// INIT YOUBORA PLUGIN
window.youboraPlugin;
window.initYouboraPlugin = (debug) => {


  const logger = (...value) => {
    if (debug) {
      console.log(...value);
    }
  }
  /**
   * 
   * @param videoMetadata 
   * @returns fully customizable key/value object 
   */
  const customTag = (videoMetadata) => {
    if (!videoMetadata) return {};
    return {
      assetState: videoMetadata.assetState,
      eventId: videoMetadata.eventId,
      is24_7: `${videoMetadata.assetState === 'live' && videoMetadata.dvrType === 'none'}`,
      is360: `${!!videoMetadata.stereoMode && videoMetadata.stereoMode !== 'none'}`,
      platform: 'Chromecast',
      spoilerMode: videoMetadata.behaviour.spoilerMode,
      videoId: videoMetadata.videoId,
      videoTitle: videoMetadata.title,
      userName: videoMetadata.customAttributes.viewerId,
    };
  };
  
  /**
   * 
   * @param videoMetadata 
   * @returns fully customizable array of values
   */
  window.customDimensions = (videoMetadata) => {
    return [
      videoMetadata.videoId,
      videoMetadata.title,
      videoMetadata.assetState,
      videoMetadata.eventId,
      'Chromecast',
      videoMetadata.behaviour.spoilerMode,
    ];
  };

  /**
   * Youbora configuration properties
   */
  window.youboraConfig = {
    playerVersion: APP_VERSION,
    accountCode: YOUBORA_ACCOUNT_CODE, // String to identify specific account code. Find your code on the account info page on NPAW
    playerName: APP_PLAYER_NAME,
    userName: 'DivaWebUser', // String to identify specific user 
    cdnName: 'AKAMAI',
    customTagGenerator: customTag,
    customDimensionsGenerator: customDimensions,
    log: debug ? logger : undefined,
  };
  console.log("window",window.youboraConfig)
  window.youboraPlugin = new divaYouboraPlugin.YouboraPlugin();
  window.youboraPlugin.init(window.youboraConfig);
}
// ---- //
